import { Directive } from '@angular/core';

@Directive({
  selector: '[app-popover-header]',
  host: { class: 'relative flex flex-col justify-center px-5 py-2 text-center' },
})
export class PopoverHeaderDirective {}
